export default  <svg xmlns="http://www.w3.org/2000/svg" width="11.667" height="22.468" viewBox="0 0 11.667 22.468">
  <path id="facebook" d="M25.808,11.343l.515-3.993H22.368V4.8c0-1.156.322-1.943,1.979-1.943h2.114V-.719a28.478,28.478,0,0,0-3.082-.157c-3.05,0-5.136,1.861-5.136,5.28V7.351H14.794v3.992h3.449V21.592h4.125V11.343Z" transform="translate(-14.794 0.876)" fill="#e23734"/>
</svg>
